import React from 'react'
import { Avatar, makeStyles } from '@fluentui/react-components'

const useStyles = makeStyles({
	wrapper: {
		position: 'relative',
		display: 'inline-flex',
		flexShrink: 0,
		// No alignSelf here — explicit width+height on the root element prevents
		// flex stretch without overriding the parent's alignment (e.g. centering in voice panel).
	},
})

type AvatarSize = 16 | 20 | 24 | 28 | 32 | 36 | 40 | 48 | 56 | 64 | 72 | 96 | 120 | 128

interface BotAvatarProps {
	size?: AvatarSize
	badge?: { status: 'available' | 'busy' | 'away' | 'offline' | 'do-not-disturb' }
}

export const BotAvatar: React.FC<BotAvatarProps> = ({ size = 40, badge }) => {
	const styles = useStyles()
	const ringSize = size + 6
	return (
		// Explicit width+height: CSS spec says align-items:stretch does not apply when
		// the child has a definite size, so the ring stays circular in any flex context.
		<div className={styles.wrapper} style={{ width: size, height: size }}>
			<Avatar
				name="Martin's CV Bot"
				size={size}
				image={{ src: '/avatar.webp' }}
				badge={badge}
				style={{ filter: 'hue-rotate(190deg) saturate(0.72) brightness(0.88)' }}
			/>
			<div style={{
				position: 'absolute',
				width: ringSize,
				height: ringSize,
				top: -3,
				left: -3,
				borderRadius: '50%',
				border: '2px solid rgba(0, 200, 255, 0.45)',
				boxShadow: '0 0 8px rgba(0, 180, 255, 0.35)',
				pointerEvents: 'none',
			}} />
		</div>
	)
}
